import React from 'react';
import styles from './styles.module.scss';

export interface CheckboxGroupProps {
  children: React.ReactNode;
}

export const CheckboxGroup = ({ children }: CheckboxGroupProps): React.ReactElement => {
  return <div className={styles.checkboxGroup}>{children}</div>;
};
